import { render, staticRenderFns } from "./MatchMakingLeaderboard.vue?vue&type=template&id=f95f6984&scoped=true"
import script from "./MatchMakingLeaderboard.vue?vue&type=script&lang=js"
export * from "./MatchMakingLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./MatchMakingLeaderboard.vue?vue&type=style&index=0&id=f95f6984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95f6984",
  null
  
)

export default component.exports